/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ShareInputs */

const th_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แชร์`)
};

const en_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share`)
};

const ja_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`共有`)
};

const zh_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分享`)
};

const es_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartir`)
};

const pt_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartilhar`)
};

const id_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagikan`)
};

const fr_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partager`)
};

const tl_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ibahagi`)
};

const vi_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chia sẻ`)
};

const ko_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공유`)
};

const de_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilen`)
};

const ru_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поделиться`)
};

const tr_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paylaş`)
};

const it_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condividi`)
};

const pl_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udostępnij`)
};

const uk_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поділитися`)
};

const hi_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`साझा करें`)
};

const ar_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مشاركة`)
};

const ms_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kongsi`)
};

const bn_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ভাগ করুন`)
};

const zh_tw2_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分享`)
};

const zh_hk2_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分享`)
};

const ur_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شیئر کریں`)
};

const fa_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هم‌رسانی`)
};

const sw_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shiriki`)
};

const nl_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delen`)
};

/**
* | output |
* | --- |
* | "Share" |
*
* @param {ShareInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const share = /** @type {((inputs?: ShareInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ShareInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_share(inputs)
	if (locale === "ja") return ja_share(inputs)
	if (locale === "zh") return zh_share(inputs)
	if (locale === "es") return es_share(inputs)
	if (locale === "pt") return pt_share(inputs)
	if (locale === "id") return id_share(inputs)
	if (locale === "fr") return fr_share(inputs)
	if (locale === "tl") return tl_share(inputs)
	if (locale === "vi") return vi_share(inputs)
	if (locale === "ko") return ko_share(inputs)
	if (locale === "de") return de_share(inputs)
	if (locale === "ru") return ru_share(inputs)
	if (locale === "tr") return tr_share(inputs)
	if (locale === "it") return it_share(inputs)
	if (locale === "pl") return pl_share(inputs)
	if (locale === "uk") return uk_share(inputs)
	if (locale === "hi") return hi_share(inputs)
	if (locale === "ar") return ar_share(inputs)
	if (locale === "ms") return ms_share(inputs)
	if (locale === "bn") return bn_share(inputs)
	if (locale === "zh-TW") return zh_tw2_share(inputs)
	if (locale === "zh-HK") return zh_hk2_share(inputs)
	if (locale === "ur") return ur_share(inputs)
	if (locale === "fa") return fa_share(inputs)
	if (locale === "sw") return sw_share(inputs)
	if (locale === "nl") return nl_share(inputs)
	return en_share(inputs)
});